import Link from 'next/link'
import { PropsWithChildren } from 'react'
import { cn, joinDomain } from '../../utils'

export function RouteLink({ children, href, className }: PropsWithChildren<PropsWithClass<{ href: string }>>) {
  return (
    <Link href={joinDomain(href)} className={cn('underline! text-primary', className)}>
      {children}
    </Link>
  )
}
